import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const TotalAnulacion = ({ anulacion }) => {

    const formatterSoles = new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' });

    var porcentajeVal = anulacion.porcentaje.substring(0, 1);
    var elem = document.getElementById('idPorcentajeanulacion');
    var elem1 = document.getElementById('iconPorcanulacion');
    if (elem != null) {
        if (porcentajeVal == '-') {
            elem.style.color = '#ff4d4d';
            elem1.style.backgroundColor = '#ff4d4d';
        } else {
            elem.style.color = '#58C347';
            elem1.style.backgroundColor = '#58C347';
        }
    }

    return (
        <>
        
        <div className="col">
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-auto">
                                <FontAwesomeIcon icon={ 'fa-solid fa-xmark' } 
                                size='2x' color='red'/>
                        </div>
                        <div className="col valortotalpasado2 d-flex align-items-center">
                            Total de anulaciones
                        </div>
                    </div>
                    <div className="totalIndicador">
                        { formatterSoles.format(anulacion.total) }
                    </div>
                    <div className="row">
                        <div className="col-auto">
                            <div className="valortotalpasado">{ anulacion.label }</div>
                            <div className="valortotalpasado2">
                                { formatterSoles.format(anulacion.totalAyer) }
                            </div>
                        </div>
                        <div className="col align-items-center">
                            <div className="row">
                                <div id="idPorcentajeanulacion" 
                                className="fw-bolder fs-4 d-flex justify-content-end col">
                                    { anulacion.porcentaje }
                                </div>
                                <div className="col-auto rounded d-flex align-items-center"
                                id='iconPorcanulacion'>
                                    <FontAwesomeIcon icon={ anulacion.icon } 
                                    color='white'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        </>
    )
}